<template>
  <div class="page-container">
    <TopNavbar :title="getNickName(authorInfo)"></TopNavbar>
    <transition name="slide">
      <div class="item-full-container">
        <list v-model="isLoading"
              :finished="isFinished"
              loading-text=" "
              finished-text="到底了"
              @load="onLoad()"
        >
          <div class="tab-item">
            <div class="item" v-for="item in userLookItemList" :key="item.id" @click="showCrawlItem(item)">
              <div class="item-detail">
                <div class="img-container">
                  <img :src="item.cover_url" alt="">
                  <div class="duration"> {{getDuration(item)}}</div>
                </div>
                <div class="desc">
                  <div class="description"> {{getTitle(item)}}</div>
                  <div class="user-nickname">{{getNickName(item)}}</div>
                </div>
              </div>
            </div>
          </div>
        </list>
      </div>
    </transition>
  </div>
</template>

<script>
  import {List, Toast} from "vant"
  import TopNavbar from "../../common/TopNavbar";

  export default {
    name: "UserAlbumPage",
    components: {TopNavbar, List, Toast},
    data() {
      return {
        showDetail: false,
        isFinished: false,
        isLoading: false,
        userLookItemList: [],
        offset: 0,
        authorInfo: {},
      };
    },
    mounted() {
    },
    methods: {
      async onLoad() {
        let queries = {
          "user_id": this.$route.params.id,
          "offset": this.offset,
        }
        await this.$store.dispatch("GetUserAlbumItems", queries).then((resp) => {
          if (resp.code === 0) {
            let data = resp.data
            let items = data.items
            this.authorInfo = data.author
            for (let i = 0; i < items.length; i++) {
              this.userLookItemList.push(items[i])
            }
            let extra = resp.extra
            if (!extra.has_more) {
              this.isFinished = true
            } else {
              this.offset = extra.max_cursor
            }
          } else {
            Toast("系统错误")
            this.isFinished = true
          }
        }, (err => {
          console.log(err)
          this.isFinished = true
        }))
        this.isLoading = false
      },

      showCrawlItem(item) {
        this.$router.push('/video/' + item.id);
      },

      getDuration(item) {
        let t = item.duration
        if (Math.floor(t / 3600) > 0) {
          return ('0' + Math.floor(t / 3600) % 24).slice(-2) + ':' + ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        } else {
          return ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        }
      },
      getTitle(item) {
        if (!item || !item.title) {
          return ""
        }
        return item.title
      },
      getNickName(user) {
        if (!user || !user.nickname) {
          return ""
        }
        return user.nickname
      },
      goBack() {
        this.$router.go(-1);
      },
    },
    computed: {}
  };
</script>
<style lang="scss" scoped>
  .page-container {
    background: white;
    min-height: 100vh;
  }

  .item-full-container {
    background: white;
    margin-top: 47px;

    .tab-item {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .item {
        width: 100%;
        margin-top: 10px;
      }
    }
  }

  .item-detail {
    display: flex;
    align-items: center;
    background-color: #fff;
    height: 100px;

    .img-container {
      /*-webkit-background-size: cover;*/
      /*background-size: cover;*/
      /*border-radius: 5px 5px 0 0;*/
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      height: 100px;
      width: 50%;
      background: black;
      align-items: center;
      margin: 3px 8px;
      flex: 0 0 auto;
      position: relative;
      overflow: hidden;
    }

    img {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      transform: translate(-50%, -50%);
    }

    .desc {
      color: #9d9d9d;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 5px 10px;
      font-size: 12px;
      overflow: hidden;
      height: 100px;

      .user-nickname {
        font-size: 12px;
        margin-top: 12px;
      }

      .description {
        color: dimgrey;
        /*max-height: 70%;*/
        /*overflow: hidden;*/
        display: block; /* or inline-block */
        text-overflow: ellipsis;
        word-wrap: break-word;
        overflow: hidden;
        max-height: 6.4em;
        line-height: 1.6em;
      }
    }

    .duration {
      position: absolute;
      right: 8px;
      bottom: 8px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      height: 18px;
      min-width: 18px;
      color: #fff;
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.7);
      line-height: 12px;
      text-align: center;
      font-size: 10px;
      padding: 3px 3px;
      vertical-align: bottom;
    }
  }


  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }

  .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }

  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }

  .block-play-tip-container {
  }

  .wx-public-follow-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 10px 0;
  }

</style>
